import classnames from 'classnames'
// SVG
import { useTranslation } from 'next-i18next'

import { BRAND_LOGO_SIZE, BRAND_LOGO_TYPES } from './BrandLogo.constants'
import styles from './brandLogo.module.scss'
import Logo from './logo.inline.svg'

export interface BrandLogoProps {
  type?: BRAND_LOGO_TYPES
  size?: BRAND_LOGO_SIZE
  className?: string
  srOnlyLabel?: string
}

export const BrandLogo = ({
  size = BRAND_LOGO_SIZE.LARGE,
  type = BRAND_LOGO_TYPES.SECONDARY,
  className,
  srOnlyLabel,
}: BrandLogoProps) => {
  const { t } = useTranslation('accountPage')

  const classNames = classnames(styles[`brand_logo_size__${size}`], styles[`brand_logo_type__${type}`], className)

  return (
    <>
      <span className="sr-only">{srOnlyLabel || t('quince')}</span>
      <Logo
        className={classNames}
        // @i18n-ignore
        role="presentation"
      />
    </>
  )
}

export default BrandLogo
